import axios from "axios";
import { API_URL } from "App";

const api = axios.create();

export const fetchShows = async () => {
  const response = await api.get(`${API_URL}/shows`);
  return response;
};
